import React from 'react';
import { SkillsData } from '../../../Assets/Data/SkillsData';
import classes from './Skills.module.css';

const Skills = () => {
  return (
    <>
      {SkillsData.map((s, i) => {
        return (
          <li className={classes.skills_container} key={i}>
            <abbr className={classes.abbr} title={s.name}>
              <img className={classes.skills_image} src={s.img} alt="aaa" />
            </abbr>
          </li>
        );
      })}
    </>
  );
};

export default Skills;
